'use client';

import { useEffect } from 'react';

/**
 * CloudWatch RUM Component
 *
 * Uses the aws-rum-web npm package for reliable RUM integration.
 * Initializes in useEffect to ensure it only runs client-side.
 */
export function CloudWatchRUM() {
  const appId = process.env.NEXT_PUBLIC_RUM_APP_ID;
  const identityPoolId = process.env.NEXT_PUBLIC_RUM_IDENTITY_POOL_ID;
  const region = process.env.NEXT_PUBLIC_RUM_REGION;

  useEffect(() => {
    // Don't initialize if config is missing
    if (!appId || !identityPoolId || !region) {
      return;
    }

    // Dynamic import to avoid SSR issues (aws-rum-web uses navigator)
    import('aws-rum-web').then(({ AwsRum }) => {
      try {
        new AwsRum(appId, '1.0.0', region, {
          sessionSampleRate: 1,
          identityPoolId,
          endpoint: `https://dataplane.rum.${region}.amazonaws.com`,
          telemetries: ['performance', 'errors', 'http'],
          allowCookies: true,
          enableXRay: false
        });
      } catch (error) {
        // Ignore errors thrown during CloudWatch RUM web client initialization
        console.error('[CloudWatchRUM] Initialization failed:', error);
      }
    });
  }, [appId, identityPoolId, region]);

  return null;
}
